
import { Box } from "@mui/material";
import { MRT_Localization_ES } from "material-react-table/locales/es";
export const localization = {
  header: {
    actions: "",
  },
  pagination: {
    labelRowsSelect: "filas",
    firstTooltip: "Primera página",
    previousTooltip: "Página anterior",
    nextTooltip: "Página siguiente",
    lastTooltip: "Última página",
    labelDisplayedRows: "{from}-{to} de {count}",
  },
  toolbar: {
    searchPlaceholder: "Buscar...",
    exportTitle: "Exportar",
    exportName: "Exportar a CSV",
    nRowsSelected: `{0} fila(s) seleccionada(s)`,
  },
};

export const tableStyles = {
  container: {
    paddingLeft: 10,
    paddingRight: 10,
    overflow: "auto",
  },
  rowStyle: {
    fontFamily: "Roboto",
    padding: 0,
  },
  headerStyle: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "0.75rem",
    lineHeight: "1.3125rem",
    fontWeight: 500,
    fontFamily: "Roboto",
  },
};


export const tableConfig = {
  cells: {
    sx: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
  muiTableHeadCellProps: {
    sx: {
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: "0.75rem",
      lineHeight: "1.3125rem",
      fontWeight: 500,
      fontFamily: "Roboto",
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      justifyContent: 'end',
      '& .MuiTableSortLabel-root': {
        marginLeft: '-4px',    // pull sort icon closer
        padding: 0,
      },
      '& .MuiTableSortLabel-icon': {
        padding: 0,
        margin: 0,
      },
    }
  },
  muiTableBodyCellProps: {
    sx: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      verticalAlign: 'top',
    }
  },
  muiTableBodyRowProps: {
    sx: {
      fontFamily: "Roboto",
      padding: 0,
    }
  },
  enableGlobalFilter: true,
  enableColumnActions: true,
  enableColumnFilters: true,
  enableFilters: true,
  enableDensityToggle: false,
  enableFullScreenToggle: false,
  enableHiding: true,
  positionToolbarAlertBanner: "top",
  positionActionsColumn: "last",
  selectAllMode: "all",
  displayColumnDefOptions: {
    'mrt-row-actions': {
      muiTableHeadCellProps: {
        align: 'center',
        sx: {
          color: "rgba(0, 0, 0, 0.54)",
          fontSize: "0.75rem",
          lineHeight: "1.3125rem",
          fontWeight: 500,
          fontFamily: "Roboto",
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          justifyContent: 'center',
          paddingBottom: '8px',
        },
      },
    },
  },
  defaultColumn: {
    maxSize: 80,
    minSize: 20,
    muiFilterTextFieldProps: {
      placeholder: '',
      InputProps: {
        endAdornment: null,
      }
    },
    Header: ({ column }) => (
      <Box
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          lineHeight: 1.2,
          fontWeight: 'bold',
        }}
      >
        {column.columnDef.header}
      </Box>
    ),
  },
  muiTableContainerProps: {
    sx: { width: '100%' },
  },
  muiTableProps: {
    sx: { width: '100%', tableLayout: 'fixed' },
  },
  initialState: {
    showColumnFilters: true,
  },
  localization: {
    ...MRT_Localization_ES,
    noRecordsToDisplay: 'Sin filas',
  },
  layoutMode: "grid",
}